import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_ID,
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling
} from '@angular/router';
import {
  API_BASE_URL,
  APP_ENVIRONMENT,
  AppContext,
  authInterceptor,
  baseUrlInterceptor,
  ChunkLoadErrorHandler,
  errorInterceptor,
  HURO_APP_ID,
  refreshAccount
} from '@umss/shared/core';
import {
  facebookSdkInitializer,
  WEB_PUSH_CONFIG
} from '@umss/shared/data-access';
import { provideUmssIcons, UmssSplashScreenService } from '@umss/shared/ui';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import {
  ContractorContextService,
  ContractorSelfAvailabilityDataService,
  ContractorTabTitleService
} from '@umss/contractor-data-access';
import { CONTRACTOR_AVAILABILITY_DATA_SERVICE } from '@umss/shared/data-access';
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    ContractorContextService,
    {
      provide: AppContext,
      useExisting: ContractorContextService
    },
    provideAppInitializer(() => refreshAccount()),
    provideAppInitializer(() => {
      inject(ContractorTabTitleService);
      inject(UmssSplashScreenService);
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, authInterceptor, errorInterceptor])
    ),
    provideUmssIcons(),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: APP_ENVIRONMENT, useValue: environment },
    {
      provide: HURO_APP_ID,
      useValue: 'contractor'
    },
    {
      provide: WEB_PUSH_CONFIG,
      useValue: {
        firebase: environment.firebase,
        vapidKey: environment.firebaseVapidKey
      }
    },
    {
      provide: CONTRACTOR_AVAILABILITY_DATA_SERVICE,
      useClass: ContractorSelfAvailabilityDataService
    },
    facebookSdkInitializer,
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'MM/dd/yyyy' }
    }
  ]
};
